import clsx from 'clsx';
import React, { type MouseEvent, type PropsWithChildren, forwardRef, useEffect } from 'react';

import styles from './TreeNodeLabel.css';

interface TreeNodeLabelProps {
    className?: string;
    promoId?: string;
    onClick?: (e: MouseEvent<HTMLDivElement>) => void;
    onShow?: () => void;
}

export const TreeNodeLabel = forwardRef<HTMLDivElement, PropsWithChildren<TreeNodeLabelProps>>(function TreeNodeLabel(
    { children, className, promoId, onClick, onShow },
    ref
) {
    useEffect(() => {
        onShow?.();
    }, [onShow]);

    return (
        <div ref={ref} className={clsx(styles.label, className)} data-promo={promoId} onClick={onClick}>
            {children}
        </div>
    );
});
